
import ViewBox from 'vux/src/components/view-box/index.vue'

import { mapState } from "vuex";
export default {
components: {
ViewBox
},
name: "App",
computed: {
data() {
return {
direction:'forward'
}
},
...mapState({
direction: state => state.vux.direction
}),
viewTransition() {
if (!this.direction) return "";
return "vux-pop-" + (this.direction === "forward" ? "in" : "out");
}
}
};



// WEBPACK FOOTER //
// ./src/App.vue